module.exports = __webpack_public_path__ + "static/media/jade-butterfly.abb33c35.gif";